const WhyChooseSection = () => {
  const features = [
    {
      title: 'Physician-Led Strategic Consulting',
      description:
        'Led by Dr. Izza Raza Sahi, MBBS, bringing clinical expertise and operational insight to every engagement.',
      large: true,
    },
    {
      title: 'Clinical Operations Specialization',
      description:
        'Deep expertise in practice management, clinical workflows, and healthcare-specific operational challenges.',
      large: false,
    },
    {
      title: 'Vendor-Neutral Technology Advisory',
      description:
        'Unbiased recommendations focused on your practice needs, not vendor partnerships or commissions.',
      large: false,
    },
    {
      title: 'Results-Driven Consulting Frameworks',
      description:
        'Proven methodologies that deliver measurable improvements in efficiency, patient satisfaction, and revenue growth.',
      large: true,
    },
    {
      title: 'End-to-End Operational Transformation',
      description:
        'Comprehensive support from assessment through implementation and ongoing optimization.',
      large: false,
    },
    {
      title: 'Digital Enablement for Modern Practices',
      description:
        'Strategic integration of CRM, CMS, EHR, and patient engagement platforms for seamless operations.',
      large: false,
    },
    {
      title: 'Executive-Level Consulting Standards',
      description:
        'Professional, strategic, and credible consulting that meets the highest standards of corporate excellence.',
      large: true,
    },
  ];

  return (
    <section id="why-choose" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
            WHY IRS VENTURES
          </p>
          <h2 className="font-serif text-5xl font-bold text-navy-primary mb-8">
            Your Strategic Partner for Practice Excellence
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`rounded-2xl p-10 transition-all duration-300 hover:scale-105 cursor-pointer ${
                feature.large
                  ? 'bg-navy-primary text-white md:col-span-2 lg:col-span-2'
                  : 'bg-white text-navy-primary shadow-lg hover:shadow-2xl'
              }`}
            >
              {feature.large ? (
                <>
                  <h3 className="font-serif text-3xl font-bold mb-6 text-white">
                    {feature.title}
                  </h3>
                  <p className="text-base text-gray-light leading-relaxed">
                    {feature.description}
                  </p>
                </>
              ) : (
                <>
                  <h3 className="text-xl font-bold mb-4 text-navy-primary">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-charcoal leading-relaxed">
                    {feature.description}
                  </p>
                  <div className="mt-6 w-12 h-12 flex items-center justify-center">
                    <i className="ri-check-line text-3xl text-gold"></i>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;